/**
 * Main app layout — TopNav + content area + AI chat widget.
 */

import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { getAiSettings } from '../../api/agent';
import ChatWidget from '../agent/ChatWidget';
import TopNav from './TopNav';

export default function AppLayout() {
  const [writeAccess, setWriteAccess] = useState(false);

  // Load AI settings once on mount — determines write access badge on chat widget
  useEffect(() => {
    getAiSettings()
      .then((s) => {
        setWriteAccess(s.ai_write_access === 'true' || s.ai_write_access === true);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <TopNav />
      <main className="p-4 md:p-6 max-w-screen-2xl mx-auto">
        <Outlet />
      </main>
      <ChatWidget writeAccess={writeAccess} />
    </div>
  );
}
